export default __webpack_public_path__ + "static/image167-9ea98413ed1a59d014c54a95adcfb784.jpg";